export const TeamType = [
    {name: "Visitante", value: 0},
    {name: "Mandante", value: 1},
]

export const TeamTypeObj = {
    Visitor: 0,
    Principal: 1,
}